import React from "react";
import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  BooleanField,
  SelectField,
  RichTextField,
  ArrayField,
  Datagrid,
} from "react-admin";
import { dateOptions, languageChoices } from "../../../utils/options";
import { Typography } from "@mui/material";

const CompetitionShow = () => {
  return (
    <Show
      title="Детайли за 
      Конкурс"
    >
      <SimpleShowLayout>
        <SelectField
          label="Език"
          source="language"
          choices={languageChoices}
        />
        <TextField
          label="Име"
          source="title"
        />{" "}
        <RichTextField
          label="Съдържание"
          source="content"
        />{" "}
        <Typography>Качени файлове</Typography>
        <ArrayField
          label=""
          source="competition_files"
        >
          {" "}
          <Datagrid
            bulkActionButtons={false}
            empty={<Typography sx={{ marginBottom: "40px", fontSize: ".8rem" }}>Няма зададени</Typography>}
          >
            <TextField
              label="Име на файл"
              source="name"
            />
            <TextField
              label="Линк"
              source="url"
            />
          </Datagrid>
        </ArrayField>
        <DateField
          label="Дата на публикуване"
          source="started_on"
          locales={"bg"}
          options={dateOptions}
        />
        <BooleanField
          label="Скрита"
          source="is_hidden"
        />
      </SimpleShowLayout>
    </Show>
  );
};

export default CompetitionShow;
